<template>
  <div>
    <div class="make_delayed_claim">
      <h2 class="make_delayed_claim_header">{{ $t(`${pagei18nKey}.header`) }}</h2>
      <h2 class="make_delayed_claim_header">{{delayedAppUrl}}</h2>
      <div class="make_delayed_claim_image">
        <img src="@/assets/theme/images/delayed-claim-app-qr.svg"/>
      </div>

      <div class="make_delayed_claim_tuorial">
        <img src="@/assets/theme/images/qr-instructions.svg"/>
      </div>

      <!-- Button -->
      <AppButton
        @click.native="onButtonClick"
        class="make_delayed_claim__button"
        :state="buttonState"
        :type="buttonType"
        :text="$t(`${pagei18nKey}.buttonText`)" />

    </div>
  </div>
</template>

<script>
import {ButtonStates, ButtonTypes} from '@/components/app-button'
import MsNavigationBar from '@/components/ms-navigation-bar'
import themeSettings from '@/theme-settings.json'
import AppSettings from '@/app-settings.json'

export default {
  name: 'MakeDelayedClaimView',
  components: {
    MsNavigationBar
  },
  data () {
    return {
      pagei18nKey: 'message.makeDelayedClaim',
      buttonType: ButtonTypes.PRIMARY,
      delayedAppUrl: themeSettings.theme.delayedAppUrl,
      isKiosk: !!AppSettings.kioskSettings
    }
  },
  computed: {
    /**
    * Gets button state
    */
    buttonState: {
      get () {
        return ButtonStates.ENABLED
      }
    }
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    onButtonClick: function () {
      // todo fire a go home event here, shouldn't add app level business logic to a view like this

      if (this.isKiosk) {
        this.$router.push('/screensaver')
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/sass/main.scss";

  .make_delayed_claim {
    @extend %app_form_container;
    text-align: center;
  }

  .make_delayed_claim_image {
    margin: $dims-spacing-xlarge 0;
    img {
      height: $dims-qr-icon-height;
      width: $dims-qr-icon-width;
    }
  }

  .make_delayed_claim_header {
    width: 100%;
    @extend %title_section;
    padding: $dims-horizontal-gutter;
  }

  .make_delayed_claim_text {
    padding: 10px 0;
  }

  .make_delayed_claim_tuorial {
    margin: $dims-spacing-xlarge 0;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
  }

  .make_delayed_claim__button {
    max-width: none;
    margin: $dims-spacing-xlarge auto 0 auto;
    padding: $dims-spacing-small 0;
  }

</style>

